import { Button, styled } from '@mui/material';
import { BUTTON_HOVER_SHADOWS } from 'src/theme/shadows';

export const NavbarMemberMainButton = styled(Button)(({ theme }) => ({
  color: theme.palette.text.secondary,
  backgroundColor: theme.palette.grey[100],
  justifyContent: 'flex-start',
  fontWeight: 'normal',
  padding: '5px 0',
  borderRadius: '4px',
  fontSize: '14px',
  width: '100%',
  '& .MuiButton-startIcon': {
    marginLeft: '12px',
    marginRight: '12px',
  },
  ':hover': {
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
    // hover時の影
    filter: BUTTON_HOVER_SHADOWS,
    // hover時のアイコンの色をメインカラーに変更
    '& .MuiButton-startIcon': {
      color: theme.palette.primary.main,
    },
  },
}));
